export default "__VITE_ASSET__f2jOTmup__"